import {
  Checkbox,
  Typography,
  Alert
} from "@mui/material";
import {StyledSelectionGrid, CheckboxItem} from "./NewOrder.styles";
import { Field } from "./NewOrder";

export const BLUETOOTH_DEVICES = [
  "Omron Wrist BPM - 7 Series",
  "Tenovi BPM - L",
  "Tenovi BPM - S",
  "Tenovi Bariatric Scale",
  "Tenovi Glucometer",
  "Tenovi Peak Flow Meter",
  "Tenovi Pulse Ox",
  "Tenovi Scale",
  "Tenovi Thermometer",
  "Tenovi Watch",
];

export const CELLULAR_DEVICES = [
  "Tenovi Cellular BPM - L",
  "Tenovi Cellular BPM - S",
  "Tenovi Cellular Glucometer",
  "Tenovi Cellular Pulse Ox",
  "Tenovi Cellular Scale",
];

interface DeviceSelectorProps {
  btDevices: string[];
  celDevices: string[];
  onToggle: (key: "btDevices" | "celDevices", item: string) => void;
}

export default function DeviceSelector({ btDevices, celDevices, onToggle }: DeviceSelectorProps) {
  return (
    <>
      <Field label="Bluetooth devices">
        <StyledSelectionGrid>
          {BLUETOOTH_DEVICES.map(device => (
            <CheckboxItem key={device}>
              <Checkbox
                checked={btDevices.includes(device)}
                onChange={() => onToggle("btDevices", device)}
                size="small"
              />
              <Typography variant="body2">{device}</Typography>
            </CheckboxItem>
          ))}
        </StyledSelectionGrid>
      </Field>
      <Field label="Cellular devices">
        <StyledSelectionGrid>
          {CELLULAR_DEVICES.map(device => (
            <CheckboxItem key={device}>
              <Checkbox
                checked={celDevices.includes(device)}
                onChange={() => onToggle("celDevices", device)}
                size="small"
              />
              <Typography variant="body2">{device}</Typography>
            </CheckboxItem>
          ))}
        </StyledSelectionGrid>
      </Field>
    </>
  );
}

export const OrderStatusAlert = (
  { status }: { status: "success" | "error" | "validationError" | null }
) => {
  if (!status) return null;

  const label = () => {
    switch (status) {
      case "success": return "Order submitted successfully";
      case "validationError": return "Please fill out all required fields";
      case "error": return "Failed to submit order";
      default: return "";
    }
  };

  return (
    <Alert
      severity={status === "success" ? "success" : "error"}
      sx={{ py: 0, alignItems: "center" }}
    >
      {label()}
    </Alert>
  );
};